import { Layout, theme } from "antd";
import React from "react";

const { Header, Content } = Layout;


export interface DraftSubPageLayoutProps {
  header: React.JSX.Element;
  children?: React.ReactNode;
}

export const DraftSubPageLayout: React.FC<DraftSubPageLayoutProps> = (props) => {
  const {
    token: { colorText },
  } = theme.useToken();
  return (
    <Layout style={{ minHeight: "100vh", width: "100%" }}>
      <Header style={{ padding: 0, height: "fit-content", color: colorText, backgroundColor: "transparent" }}>{props.header}</Header>
      <Content
        style={{
            marginTop: '90px',
            padding: '0 48px 48px',
            alignItems: 'center',
        }}
      >

        {props.children}
      </Content>
    </Layout>
  );
};
